module.exports = __webpack_public_path__ + "img/img1.222b27bf.jpg";